import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./IndividualJoin.css";
import SignUpForm from "../components/Signupform";
import WeeklyMatchCountdown from "../components/WeeklyMatchCountdown";
import { Link } from 'react-router-dom';

const IndividualJoin = () => {
  const { groupID } = useParams();
  const [myCommunity, setMyCommunity] = useState(null);

  // Just this community (~6 KB) — not the whole list of every community,
  // which held the page on "Loading..." on slow phones.
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/communities/${groupID}`);
        if (response.ok && !cancelled) setMyCommunity(await response.json());
      } catch { /* stays on Loading… */ }
    })();
    return () => { cancelled = true; };
  }, [groupID]);

  // The 'signup_page_blurb' A/B test ended (1 Nov 2026): everyone gets B —
  // no group description, and a bigger "Free…" line. (A showed the
  // description; its results stay in Admin → A/B Test.)
  const blurb = { variant: 'B' };

  if (!myCommunity) {
    return <div className="individualjoin-loading-indicator">Loading...</div>;
  }

  // What the group is about and what happens after signing up, in the
  // group's own words ("theatregoers", "riders") — so someone arriving from
  // an ad sees it's the group they meant, and that joining commits them to
  // nothing.
  const countdown = myCommunity.interconnectingMode === 'countdown';
  const peopleWord = myCommunity.quickMatchPeopleWord || 'people';
  const pic = (myCommunity.pics || []).find(x => typeof x === 'string' && x) || null;

  return (
    <div className="individualjoin-signup-form">
      <div className="individualjoin-header-row">
        {pic && (
          <div className="individualjoin-image-container">
            <img
              src={pic}
              alt={myCommunity.title}
              className="individualjoin-signup-form-image"
            />
          </div>
        )}
        <div className="individualjoin-info" style={myCommunity.interconnectingMode === 'countdown' ? { textAlign: 'center' } : undefined}>
          <h2 className="individualjoin-title">
            {myCommunity.interconnectingMode === 'countdown' ? '' : 'Join '}{myCommunity.title}
          </h2>
          <h3 className="individualjoin-subtitle">
            {myCommunity.subtitle}
          </h3>
          {myCommunity.interconnectingMode === 'countdown' && (
            <p className="individualjoin-subtitle" style={{ marginTop: '-0.1rem' }}>
              Sign up to get weekly match suggestions
            </p>
          )}
          {myCommunity.interconnectingMode === 'countdown' && myCommunity.suggestionsRounds && (
            <div style={{ margin: '0.75rem 0' }}>
              <WeeklyMatchCountdown
                dayOfWeek={myCommunity.suggestionsRounds.dayOfWeek}
                hour={myCommunity.suggestionsRounds.hour}
                light
                hideTimer
              />
            </div>
          )}
          {blurb.variant === 'A' && myCommunity.topLevelSummary && (
            <p className="individualjoin-summary">{myCommunity.topLevelSummary}</p>
          )}
          {!countdown && (
            <ul className="individualjoin-steps">
              <li>Answer a few quick questions about you</li>
              <li>We introduce you to {peopleWord} near you</li>
              <li>You choose who to chat with{myCommunity.matchActivity ? ` and ${myCommunity.matchActivity}` : ''}</li>
            </ul>
          )}
          <p className={`individualjoin-free-note${blurb.variant === 'B' ? ' individualjoin-free-note--big' : ''}`}>Free. No hidden costs. Nothing.</p>
          <p className="individualjoin-login-prompt">
            Already a member? <Link to="/login">Log in</Link>
          </p>
        </div>
      </div>
      <SignUpForm
        community={myCommunity} 
        communityId={myCommunity._id} 
        communityName={myCommunity.title} 
      />
    </div>
  );
};

export default IndividualJoin;



// import { useEffect } from "react";
// import { useCommunitiesContext } from "../hooks/useCommunitiesContext";
// //import { useParams } from 'react-router-dom';
// import "./IndividualJoin.css";
// import SignUpForm from "../components/Signupform";
// import { Link } from 'react-router-dom';

// // ...
// import { useAuthContext } from "../hooks/useAuthContext";

// <h5 id="h5-form">Sign up or <Link to="/login" style={{ textDecoration: 'underline' }}>log in</Link> to join this group</h5>

// const IndividualJoin = () => {
//   const { x, dispatch } = useCommunitiesContext();
//   // const user = useAuthContext();

//   // useEffect(() => {
//   //   if(!user) return
//   //   navigate("/Profileupdate");
//   //   }

//   // }, [user])

//   useEffect(() => {
//     const fetchCommunities = async () => {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_BASE_URL}/communities`
//       );

//       const json = await response.json();

//       if (response.ok) {
//         dispatch({ type: "SET_COMMUNITIES", payload: json });
//       }
//     };

//     fetchCommunities();
//   }, [dispatch]);

//   const currentURL = window.location.href;
//   const segments = currentURL.split("/");
//   const lastSegment = segments.pop();
//   const { communities } = useCommunitiesContext();

//   const myCommunity = communities.find((tree) => tree._id === lastSegment);

//   // Check if myCommunity is defined before rendering the component
//   if (!myCommunity) {
//     // Optionally, render a loading indicator or a message
//     return <div>Loading...</div>;
//   }

//   return  (
//     <div className="community-signup-form">
//       {/* <h1 id="community-title-join">
//         Join
//       </h1> */}
//       <h2 id="community-second-title">
//          Join {myCommunity.title}
//       </h2>
//       <h2 id="community-second-title">
//          {myCommunity.subtitle}
//       </h2>
//       {/* <h3 id="community-third-title">
//         <strong>Interconnector</strong>
//       </h3> */}
//       <div className="image-container">
//         <img
//           src={myCommunity.pics[0]}
//           alt="Image place holder"
//           className="community-signup-form-image"
//         />
//       </div>
//       <div className="community-signup-form">
//         <h5 id="h5-form">Sign up or log in to join this group</h5>
//         <SignUpForm community={myCommunity} communityId={myCommunity._id} />
//       </div>
//     </div>
//   );
// };

// export default IndividualJoin;

// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom"; // Import useNavigate for redirection
// import { useCommunitiesContext } from "../hooks/useCommunitiesContext";
// import { useAuthContext } from "../hooks/useAuthContext"; // Import useAuthContext to access user information
// import "./IndividualJoin.css";
// import SignUpForm from "../components/SignUpForm";
// import ClipLoader from "react-spinners/ClipLoader"; // Import a spinner component

// const IndividualJoin = () => {
//   const { communities, dispatch } = useCommunitiesContext();
//   const { user } = useAuthContext(); // Access user information
//   const [isLoading, setIsLoading] = useState(false); // State to manage loading state
//   const navigate = useNavigate(); // Hook for redirection

//   useEffect(() => {
//     const fetchCommunities = async () => {
//       const response = await fetch('/api/communities');
//       const json = await response.json();

//       if (response.ok) {
//         dispatch({ type: 'SET_COMMUNITIES', payload: json });
//       }
//     };

//     fetchCommunities();
//   }, [dispatch]);

//   const handleJoin = async () => {
//     if (!user) return; // Ensure user is defined
//     setIsLoading(true); // Set loading state to true

//     try {
//       const response = await fetch('/api/joinCommunity', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ communityId: myCommunity._id, userId: user.userId }),
//       });

//       if (response.ok) {
//         navigate('/profileUpdate'); // Redirect on success
//       } else {
//         // Handle errors or unsuccessful response
//         console.error('Failed to join community');
//       }
//     } catch (error) {
//       console.error('Error joining community:', error);
//     } finally {
//       setIsLoading(false); // Reset loading state
//     }
//   };

//   const currentURL = window.location.href;
//   const segments = currentURL.split('/');
//   const lastSegment = segments.pop();
//   const myCommunity = communities.find(tree => tree._id === lastSegment);

//   if (!myCommunity) {
//     return <div>Loading...</div>;
//   }

//   if (isLoading) {
//     return <ClipLoader color="#52bfd9" size={100} />; // Display spinner while loading
//   }

//   return (
//     <div className="ijoin">
//       <h4>Join the</h4>
//       <img
//         src="https://t3.ftcdn.net/jpg/02/48/42/64/360_F_248426448_NVKLywWqArG2ADUxDq6QprtIzsF82dMF.jpg"
//         alt="Image placeholder"
//         className="community-image"
//       />
//       <h2><strong>{myCommunity.title}</strong></h2>
//       <h2>Interconnector</h2>
//       <div className="i-community">
//         <h3>Sign up or log in to join this group</h3>
//         {/* Replace SignUpForm with a button to handle join action */}
//         <button onClick={handleJoin}>Join</button>
//       </div>
//     </div>
//   );
// };

// export default IndividualJoin;
